"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventNotificationToJSON = exports.EventNotificationFromJSONTyped = exports.EventNotificationFromJSON = exports.instanceOfEventNotification = exports.EventNotificationNotificationTypeEnum = void 0;
const FieldDetails_1 = require("./FieldDetails");
const GroupName_1 = require("./GroupName");
const ProjectRole_1 = require("./ProjectRole");
const UserDetails_1 = require("./UserDetails");
/**
 * @export
 */
exports.EventNotificationNotificationTypeEnum = {
    CurrentAssignee: 'CurrentAssignee',
    Reporter: 'Reporter',
    CurrentUser: 'CurrentUser',
    ProjectLead: 'ProjectLead',
    ComponentLead: 'ComponentLead',
    User: 'User',
    Group: 'Group',
    ProjectRole: 'ProjectRole',
    EmailAddress: 'EmailAddress',
    AllWatchers: 'AllWatchers',
    UserCustomField: 'UserCustomField',
    GroupCustomField: 'GroupCustomField'
};
/**
 * Check if a given object implements the EventNotification interface.
 */
function instanceOfEventNotification(value) {
    return true;
}
exports.instanceOfEventNotification = instanceOfEventNotification;
function EventNotificationFromJSON(json) {
    return EventNotificationFromJSONTyped(json, false);
}
exports.EventNotificationFromJSON = EventNotificationFromJSON;
function EventNotificationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'emailAddress': json['emailAddress'] == null ? undefined : json['emailAddress'],
        'expand': json['expand'] == null ? undefined : json['expand'],
        'field': json['field'] == null ? undefined : (0, FieldDetails_1.FieldDetailsFromJSON)(json['field']),
        'group': json['group'] == null ? undefined : (0, GroupName_1.GroupNameFromJSON)(json['group']),
        'id': json['id'] == null ? undefined : json['id'],
        'notificationType': json['notificationType'] == null ? undefined : json['notificationType'],
        'parameter': json['parameter'] == null ? undefined : json['parameter'],
        'projectRole': json['projectRole'] == null ? undefined : (0, ProjectRole_1.ProjectRoleFromJSON)(json['projectRole']),
        'recipient': json['recipient'] == null ? undefined : json['recipient'],
        'user': json['user'] == null ? undefined : (0, UserDetails_1.UserDetailsFromJSON)(json['user']),
    };
}
exports.EventNotificationFromJSONTyped = EventNotificationFromJSONTyped;
function EventNotificationToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'emailAddress': value['emailAddress'],
        'expand': value['expand'],
        'field': (0, FieldDetails_1.FieldDetailsToJSON)(value['field']),
        'group': (0, GroupName_1.GroupNameToJSON)(value['group']),
        'id': value['id'],
        'notificationType': value['notificationType'],
        'parameter': value['parameter'],
        'projectRole': (0, ProjectRole_1.ProjectRoleToJSON)(value['projectRole']),
        'recipient': value['recipient'],
        'user': (0, UserDetails_1.UserDetailsToJSON)(value['user']),
    };
}
exports.EventNotificationToJSON = EventNotificationToJSON;
//# sourceMappingURL=EventNotification.js.map